import { render, staticRenderFns } from "./DraggableSongHandle.vue?vue&type=template&id=038b568e"
import script from "./DraggableSongHandle.vue?vue&type=script&lang=js"
export * from "./DraggableSongHandle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports